import React from "react";

const OrderCreationInfoIcon = ({ color = "#6D7885", ...rest }) => {
  return (
    <svg preserveAspectRatio="none" overflow="visible" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g>
        <path fillRule="evenodd" clipRule="evenodd" d="M10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125ZM1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10Z" fill={color} />
        <path fillRule="evenodd" clipRule="evenodd" d="M8.75 9.375C8.75 9.02982 9.02982 8.75 9.375 8.75H10C10.3452 8.75 10.625 9.02982 10.625 9.375V13.125C10.9702 13.125 11.25 13.4048 11.25 13.75C11.25 14.0952 10.9702 14.375 10.625 14.375H10C9.65482 14.375 9.375 14.0952 9.375 13.75V10C9.02982 10 8.75 9.72018 8.75 9.375Z" fill={color} />
        <path d="M9.84375 7.5C10.3615 7.5 10.7812 7.08027 10.7812 6.5625C10.7812 6.04473 10.3615 5.625 9.84375 5.625C9.32598 5.625 8.90625 6.04473 8.90625 6.5625C8.90625 7.08027 9.32598 7.5 9.84375 7.5Z" fill={color} />
      </g>
    </svg>
  );
};

export default OrderCreationInfoIcon;
